import * as GroupsActionTypes from '../../types/groups';
import * as GroupsApis from '../../apis/groups';
import * as SettingsSelectors from '../../selectors/settings';
import * as GroupsErrors from '../../errors/groups';
import * as GroupsSelectors from '../../selectors/groups';
import * as FilerrsSelectors from '../../selectors/filerrs';
import * as CollaboratorsActions from '../collaborators';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as groupTypes from './groupTypes';

/**
 * Sets the groups in store
 * @param {object} payload {<groupId>: <groupData>}
 */
export const setGroups = (payload) => ({
    type: GroupsActionTypes.SET_GROUPS,
    payload
});

/**
 * Add a new group to store
 * @param {object} payload
 * @param {string} payload.id - The collaboration group id
 * @param {string} payload.type - the collaboration group type
 * @param {array<string>} payload.fileIds - an array of collaboration file ids that relates to the group
 */
export const addGroup = (payload) => ({
    type: GroupsActionTypes.ADD_GROUP,
    payload
});

/**
 * Delete a group from store
 * @param {string} id - Collaboration group id
 */
export const deleteGroup = (id) => ({
    type: GroupsActionTypes.DELETE_GROUP,
    payload: id
});

/**
 * Create collaboration group
 * @param {string} type - the collaboration group type
 * @param {array<string>} filerrIds - an array of collaboration file ids that relates to the group
 * @returns {Promise}
 * @rejects {Error}
 */
export const createGroup = (type, filerrIds) => (dispatch, getState) =>
    Promise.resolve().then(() => ({
        type,
        filerrIds,
        contextId: SettingsSelectors.getContextId(getState()),
        contextType: SettingsSelectors.getContextType(getState())
    })).then((payload) =>
        GroupsApis.create(payload)
    ).then((group) => {
        dispatch(addGroup(group));
        return group;
    }).catch((error) => {
        if (!error.code) {
            error.code = GroupsErrors.GROUPS_ACTIONS_CREATE_CROUP_UNEXPECTED;
            error.details = { payload: { type, filerrIds } };
        }

        throw error;
    });

export const getOrCreateCollaborationGroupId = () => async(dispatch, getState) => {
    // 1- if collaborator group exists, return its group id
    const groupId = GroupsSelectors.getGroupIdByType(getState(), groupTypes.COLLABORATORS);
    if (groupId) {
        return groupId;
    }

    // 2- create group
    const filerrIds = FilerrsSelectors.getFilerrIds(getState());
    const { id } = await dispatch(createGroup(groupTypes.COLLABORATORS, filerrIds));

    // 3- create collaborator for the collaborators group
    const { userId } = CollaboratorsSelectors.getCurrentCollaborator(getState());
    const newCollaborator = { userId, groupId: id, invite: true };
    await dispatch(CollaboratorsActions.createCollaborator(newCollaborator));

    // 4- return the collaborator group id
    return id;
};

export const updateLastSeen = (groupType) => (dispatch, getState) => {
    const groupId = GroupsSelectors.getGroupIdByType(getState(), groupType);
    const id = CollaboratorsSelectors.getCurrentCollaboratorIdByGroupId(getState(), groupId);
    const lastSeen = new Date().getTime() / 1000;

    return dispatch(CollaboratorsActions.updateCollaborator({ id, lastSeen }));
};
